export default "__VITE_ASSET__VRJJZXJD__"